export default __webpack_public_path__ + "static/media/Francesco-auf-Roller.272151dd.webp";